// Map common text emoticons to emoji. Longer/more-specific keys first.
const MAP = [
  [";)", "😉"], [";-)", "😉"],
  [":)", "🙂"], [":-)", "🙂"], [":]", "🙂"],
  [":D", "😄"], [":-D", "😄"], ["xD", "😆"], ["XD", "😆"],
  [":(", "🙁"], [":-(", "🙁"], [":[", "🙁"],
  [":O", "😮"], [":o", "😮"], [":-O", "😮"], [":-o", "😮"],
  [":P", "😛"], [":p", "😛"], [":-P", "😛"], [":-p", "😛"],
  [";P", "😜"], [";p", "😜"],
  [":'(", "😢"],
  [":|", "😐"], [":-|", "😐"],
  [":*", "😘"], [":-*", "😘"],
  ["<3", "❤️"], ["</3", "💔"],
  [":/", "😕"], [":-/", "😕"], [":\\", "😕"],
  ["B)", "😎"], ["8)", "😎"],
  [">:(", "😠"], [">:)", "😈"],
  [":3", "😊"], ["^^", "😊"], ["^_^", "😊"],
  ["o/", "👋"],
];

// Replace emoticons when bounded by start/end/whitespace so we don't mangle URLs etc.
export function convertEmoticons(input) {
  if (!input) return input;
  let out = input;
  for (const [sym, emoji] of MAP) {
    const esc = sym.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    const re = new RegExp("(^|\\s)" + esc + "(?=\\s|$)", "g");
    out = out.replace(re, "$1" + emoji);
  }
  return out;
}
